import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWallUp"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2L20 2V4L4 4L4 2ZM12 5.58579L17.6642 11.25L16.25 12.6642L13 9.41422L13 22H11L11 9.41421L7.75 12.6642L6.33579 11.25L12 5.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallUp;
